module.exports = __webpack_public_path__ + "img/triangle-middle.9924daf4.png";